import Vue from "vue";
import { Loading } from "element-ui";

import utils from "./utils";
import store from "../../store";

Vue.use(Loading.directive);

let loading,
  needLoadingRequestCount = 0;
const common = {
  /**
   * @func 加载loading方法
   */
  startLoading() {
    // 定义loading-start方法
    loading = Loading.service({
      lock: true,
      text: "加载中，请稍后...",
      spinner: "el-icon-loading",
      background: "rgba(225, 225, 225, 0.5)"
    });
  },
  /**
   * @func 关闭loading方法
   */
  endLoading() {
    // 定义loading-end方法
    loading.close();
  },
  /**
   * @func 请求接口加载loading方法
   */
  showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
      common.startLoading();
    }
    needLoadingRequestCount++;
  },
  /**
   * @func 返回响应关闭loading方法
   */
  tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
      common.endLoading();
    }
  },
  /**
   * @func 返回当前跳转url
   * @param URL -需要跳转的地址
   * @param id -跳转需要参数taskId
   */
  getGoUrl(URL, id) {
    return (
      "/#" +
      URL +
      "?taskId=" +
      id +
      "&systemId=" +
      utils.getUrlParam().systemId +
      "&paddingNone=" +
      (utils.getUrlParam().paddingNone || 0) +
      "&currentActivityId=" +
      (utils.getUrlParam().currentActivityId || 0) +
      "&render=" +
      (utils.getUrlParam().render || 0) +
      "&toprocessinfo=" +
      (utils.getUrlParam().toprocessinfo || 0) +
      "&componentType=" +
      (utils.getUrlParam().componentType || 0) +
      "&historyGo=" +
      (utils.getUrlParam().historyGo || 0) +
      "&needBack=" +
      (utils.getUrlParam().needBack || 0) +
      "&originalTargetUri=" +
      (utils.getUrlParam().originalTargetUri || 0)
    );
  },
  getGoUrlInstance(URL, id) {
    let paddingNone;
    if (utils.getUrlParam().paddingNone == 1) {
      paddingNone = 1;
    } else {
      paddingNone = 0;
    }
    return (
      URL +
      "?instanceId=" +
      id +
      "&systemId=" +
      utils.getUrlParam().systemId +
      "&paddingNone=" +
      paddingNone
    );
  },

  changeUrlArg(url, arg, val) {
    if (
      utils.getUrlParam().currentActivityId != "0" &&
      utils.getUrlParam().currentActivityId
    ) {
      var re = new RegExp("(" + arg + "=)([^&]*)", "gi");
      var replaceText = arg + "=" + val;
      var nUrl = url.replace(re, replaceText);
      return nUrl;
    } else {
      return url;
    }
  },

  changeRealUrlArg(url, arg, val) {
    var re = new RegExp("(" + arg + "=)([^&]*)", "gi");
    var replaceText = arg + "=" + val;
    var nUrl = url.replace(re, replaceText);
    return nUrl;
  },
  funcUrlDel(name, instanceId) {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname;
    var hash = loca.hash.split("?")[0];
    var query = loca.hash.split("?")[1];
    if (query.indexOf(name) > -1) {
      var obj = {};
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      }
      delete obj[name];
      delete obj["token"];
      var url =
        baseUrl +
        hash +
        "?" +
        `instanceId=${instanceId}&` +
        JSON.stringify(obj)
          .replace(/[\"\{\}]/g, "")
          .replace(/\:/g, "=")
          .replace(/\,/g, "&");

      return url;
    }
  },
  funcUrlDelToken() {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname;
    var hash = loca.hash.split("?")[0];
    var query = loca.hash.split("?")[1];
    if (query.indexOf(name) > -1) {
      var obj = {};
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      }
      delete obj["token"];
      var url =
        baseUrl +
        hash +
        "?" +
        JSON.stringify(obj)
          .replace(/[\"\{\}]/g, "")
          .replace(/\:/g, "=")
          .replace(/\,/g, "&");

      return url;
    }
  },
  /**
   * @func 跳转到指定url,移动端用window.location.replace，pc用window.location.href
   */
  locationType() {
    let isPc = utils.isPC();
    let obj = {
      href: ""
    };
    Object.defineProperty(obj, "href", {
      //监听属性变化，跳转url
      set: function(val) {
        if (isPc) {
          window.location.href = val;
        } else {
          location.replace(val);
        }
      }
    });
    return obj;
  },

  /**
   * @func 控制iframe
   */
  displayIframe() {
    let route = utils.getUrlParam().route,
      iframRoute = [
        "/iframeForm",
        "/hasHandle",
        "/hasHandle/iframeForm",
        "/process",
        "/process/iframeForm",
        "/process/readingLog"
      ],
      routeIframe =
        iframRoute.indexOf(route) > -1 ? "iframeForm_show" : "iframeForm_hide";
    store.commit("showIframe", routeIframe);
  },
  $createIfm: function(type, value, callbackName) {
    try {
      // 龙信汇总
      createIfm(type, value, callbackName);
    } catch (e) {
      console.log(e);
    }
  },
  isTipNoClose() {
    if (!vm.$store.state.isShowOptionBox || vm.$store.state.isfirstProcess) {
      window.location.reload();
    } else {
      history.go(-1);
    }
  },
  //关闭页签
  isPRocessorBack: function(vm, action = "") {
    if (vm.$store.state.reloadTabRole == "true") {
      if (action == "PROCESS" || action == "SUBMIT") {
        window.location.href = common.changeRealUrlArg(
          window.location.href,
          "originalTargetUri",
          "0"
        );
        window.location.reload();
        return;
      }
    }
    if (vm.$store.state.reloadTab == "true") {
      if (action == "PROCESS" || action == "SUBMIT") {
        window.location.href = common.changeRealUrlArg(
          window.location.href,
          "originalTargetUri",
          "0"
        );
      }
      window.location.reload();
    } else {
      if (
        navigator.userAgent.indexOf("Firefox") != -1 ||
        navigator.userAgent.indexOf("Chrome") != -1
      ) {
        window.open("", "_self", "");
        window.close();
        if (action == "PROCESS" || action == "SUBMIT") {
          window.location.href = common.changeRealUrlArg(
            window.location.href,
            "originalTargetUri",
            "0"
          );
        }
        window.location.reload();
      } else {
        window.opener = null;
        window.open("", "_self");
        window.close();
      }
    }
  },
  submitSelect(vm, action, postData, actionName, isLongfor) {
    let sessionObj;
    if (!vm.$store.state.isPc) {
      sessionObj = sessionStorage.getItem("saveObj");
      sessionObj = JSON.parse(sessionObj);
    } else {
      sessionObj = vm.$store.state.saveObj;
    }

    let saveObj = {};
    for (const key in sessionObj) {
      const element = sessionObj[key];
      for (const k in element) {
        const value = element[k];
        for (let i = 0; i < value.length; i++) {
          if (value[i].bole || value[i].pass) {
            if (!saveObj[key]) {
              saveObj[key] = {};
            }
            if (!saveObj[key][value[i].participant.attributes.roleCode]) {
              saveObj[key][value[i].participant.attributes.roleCode] = [];
            }
            let participant = JSON.parse(JSON.stringify(value[i].participant));
            delete participant.selectBtn;
            delete participant.stage;
            delete participant.personList;
            delete participant.attributes;
            saveObj[key][value[i].participant.attributes.roleCode].push(
              participant
            );
          }
        }
      }
    }

    vm.$axios(
      "post",
      `bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/appoint-participants?submitControl=${vm.$store.state.submitControl}`,
      saveObj,
      vm
    ).then(res => {
      zhuge.track("选择审批人详细人员", {
        person: vm.$store.state.participant,
        catalogName: vm.$store.state.catalogName,
        processCHName: vm.$store.state.processCHName,
        systemNo: vm.$store.state.systemNo,
        processDefName: vm.$store.state.processDefName,
        saveObj: saveObj
      });
      if (res.data.result == false) {
        return vm.$utils.message(vm, "error", res.data.message);
      }

      if (action == "SUBMIT") {
        if (vm.$store.state.isAssign) {
          postData.isAssign = vm.$store.state.isAssign;
        }
        if (vm.$store.state.nextActivityDefId) {
          postData.nextActivityId = vm.$store.state.nextActivityDefId;
        }
        vm.$axios("put", `${vm.api.submit}`, postData, vm).then(res => {
          sessionStorage.removeItem("saveObj");
          try {
            vm.$store.state.isShow = false;
            vm.$utils.message(vm, "success", "操作成功");
            clearTimeout(timer);
            if (vm.$store.state.messageSubmitFather) {
              window.parent &&
                window.parent.postMessage({ effect: "processSucess" }, "*"); //成功
            }
            let timer = setTimeout(() => {
              if (!vm.$store.state.isPc) {
                if (vm.$store.state.reloadTabRole == "true") {
                  common.isTipNoClose();
                  return;
                }
                if (!isLongfor) {
                  history.go(-2);
                }
                if (vm.$store.state.render) {
                  createIfm("close", "refreshList()");
                } else {
                  createIfm("close");
                }
              }
              if (vm.$store.state.isPc) {
                if (
                  vm.$utils.getUrlParam().historyGo &&
                  vm.$utils.getUrlParam().historyGo != "0"
                ) {
                  window.location.href = decodeURIComponent(
                    vm.$utils.getUrlParam().historyGo
                  );
                } else {
                  common.isPRocessorBack(vm, action);
                }
              }
            }, 2000);
          } catch (e) {
            vm.$utils.message(vm, "error", "失败");
          }
        });
      }
      if (action == "PROCESS") {
        postData.actionName = actionName;
        vm.$axios(
          "put",
          `/bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/start`,
          postData,
          vm
        ).then(res => {
          sessionStorage.removeItem("saveObj");
          try {
            if (vm.$store.state.messageSubmitFather) {
              window.parent &&
                window.parent.postMessage({ effect: "processSucess" }, "*"); //成功
            }
            vm.$store.state.isShow = false;

            vm.$utils.message(vm, "success", "提交成功");
            clearTimeout(timer);
            let timer = setTimeout(() => {
              if (vm.$store.state.isPc) {
                if (
                  vm.$utils.getUrlParam().historyGo &&
                  vm.$utils.getUrlParam().historyGo != "0"
                ) {
                  window.location.href = decodeURIComponent(
                    vm.$utils.getUrlParam().historyGo
                  );
                } else {
                  common.isPRocessorBack(vm, action);
                }
              }
              if (!vm.$store.state.isPc) {
                if (vm.$store.state.reloadTabRole == "true") {
                  common.isTipNoClose();
                  return;
                }
                if (!isLongfor) {
                  history.go(-2);
                }
                if (vm.$store.state.render) {
                  createIfm("close", "refreshList()");
                } else {
                  createIfm("close");
                }
              }
            }, 800);
          } catch (e) {
            vm.$utils.message(vm, "error", "提交失败");
          }
        });
      }
    });
  }
};

export default common;



// WEBPACK FOOTER //
// ./src/assets/js/common.js